// TODO replace axios post
import axios from 'axios'
import CSRF from '@/services/csrf'
import store from '@/store/index'

const PASSWORD_RESET_REQUEST_ENDPOINT = '/api/password/reset/'
const PASSWORD_RESET_CONFIRM_ENDPOINT = '/api/password/reset/confirm/'

export default {
  logout,
  getAuthorizationHeader,
  requireAuth,
  requireNoAuth,
  passwordResetRequest,
  passwordResetConfirm,
}

/* Perform logout by clearing the Vuex store. */
function logout() {
  store.commit('LOGOUT_USER')
}

function getAuthorizationHeader() {
  return store.state.token ? { Authorization: `Token ${store.state.token}` } : {}
}

/*
 * @function requireAuth
 * @description vue-router beforeEnter-style function to check user auth
 *              status and redirect appropriately.
 */
function requireAuth(to, from, next) {
  if (!isLoggedIn()) {
    next({
      path: '/login',
    })
  } else {
    next()
  }
}

function requireNoAuth(to, from, next) {
  if (isLoggedIn()) {
    next({
      path: '/',
    })
  } else {
    next()
  }
}

function isLoggedIn() {
  return !!store.state.token
}

/**
 * @function    passwordResetRequest
 * @description Submit user's email to request a reset link.
 */
function passwordResetRequest(email) {
  const data = {
    email,
  }
  if (process.env.NODE_ENV === 'development') {
    data.domain = 'localhost:8080'
  }
  const promise = axios.post(PASSWORD_RESET_REQUEST_ENDPOINT, data, { headers: CSRF.getHeaders() })
  return promise
    .then(response => {
      return response.data
    })
    .catch(() => {
      // TODO process error
    })
}

/**
 * @function    passwordResetConfirm
 * @description Send new user's password
 */
function passwordResetConfirm(password, confirmPassword, uid, token) {
  const promise = axios.post(
    `${PASSWORD_RESET_CONFIRM_ENDPOINT}`,
    {
      new_password1: password,
      new_password2: confirmPassword,
      uid,
      token,
    },
    { headers: CSRF.getHeaders() },
  )
  return promise
    .then(response => {
      return response.data
    })
    .catch(() => {
      // TODO process error
    })
}
